import PropTypes from 'prop-types';

import exploitationProp from 'components/propTypes/exploitation';

export default PropTypes.shape({ name: PropTypes.string, exploitation: exploitationProp });
